export default [
    "34 34",
    '<circle cx="17" cy="17" r="17" fill="var(--ci-primary-color, currentColor)""/>\n' +
    '<path d="M12.5 23.75H21.5M17 10.25V20.75M17 20.75L20.75 17M17 20.75L13.25 17" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>'
]

